import { setHours, setMinutes, setSeconds } from 'date-fns';
import { toDate } from 'date-fns-tz';

import { SYSTEM_TIMEZONE } from './time-zone';

interface BuildDateWithTimeProps {
  date: Date | undefined;
  time: string;
  timeZone?: string;
}

export function buildDateWithTime({
  date,
  time,
  timeZone = SYSTEM_TIMEZONE,
}: BuildDateWithTimeProps): Date {
  const [hh, mm] = time.split(':').map(Number);
  const zonedDate = toDate(date ?? new Date(), { timeZone });
  return setSeconds(setHours(setMinutes(zonedDate, mm), hh), 0);
}
